import { $ } from "../third-party-imports"
export function startLoader() {
    $('#loader-wrapper-img').addClass('loader-wrapper-test');
    $('#img-loader').addClass('loader-ring-test');
    $('body').append('<div id = "overlayrow"></div>');
    $('#overlayrow').addClass('overlay');
}